export default {
    items: [
        // {
        //   title: true,
        //   name: 'Admin',
        //   class: '',
        //   wrapper: {
        //     element: '',
        //     attributes: {}
        //   },
        //   regras: ['CTRLACS-USR-00', 'CTRLACS-PA-00', 'CTRLACS-RA-00']
        // },
        {
            name: 'Controle de Acesso',
            url: '/admin/controleacesso',
            icon: 'fa fa-vcard-o',
            badge: {
                variant: 'primary',
                text: ''
            },
            regras: ['CTRLACS-USR-00', 'CTRLACS-PA-00', 'CTRLACS-RA-00'],
            children: [
                {
                    name: 'Usuários',
                    url: '/admin/controleacesso/usuarios',
                    icon: 'fa fa-users',
                    regras: 'CTRLACS-USR-00'
                },
                {
                    name: 'Perfis de Acesso',
                    url: '/admin/controleacesso/perfisacesso',
                    icon: 'fa fa-user-secret',
                    regras: 'CTRLACS-PA-00'
                },
                {
                    name: 'Regras de Acesso',
                    url: '/admin/controleacesso/regrasacesso',
                    icon: 'fa fa-key',
                    regras: 'CTRLACS-RA-00'
                }
            ]
        },
        // {
        //   title: true,
        //   name: 'Menu Principal',
        //   class: '',
        //   wrapper: {
        //     element: '',
        //     attributes: {}
        //   }
        // },
        {
            name: 'Credor',
            icon: 'fa fa-building',
            url: '/credores',
            badge: {
                variant: 'primary',
                text: ''
            },
            regras: [
                'CRED-PAINEL-00',
                'CRED-CART-00',
                'CRED-RECEB-00',
                'CRED-DEVOL-00',
                'CRED-PARCELAS-00'
            ],
            children: [
                {
                    name: 'Painel',
                    url: '/credores/painel',
                    icon: 'fa fa-bar-chart',
                    regras: ['CRED-PAINEL-00']
                },
                {
                    name: 'Posição da Carteira',
                    url: '/credores/carteiras',
                    icon: 'fa fa-money',
                    regras: ['CRED-CART-00']
                },
                {
                    name: 'Recebimentos',
                    url: '/credores/recebimentos',
                    icon: 'fa fa-dollar',
                    regras: ['CRED-RECEB-00']
                },
                {
                    name: 'Títulos Devolvidos',
                    url: '/credores/devolvidos',
                    icon: 'fa fa-undo',
                    regras: ['CRED-DEVOL-00']
                },
                {
                    name: 'Parcelas Vencimento',
                    url: '/credores/parcelas',
                    icon: 'fa fa-credit-card',
                    regras: ['CRED-PARCELAS-00']
                },
                {
                    name: 'Deved. ajuizados',
                    url: '/credores/devedoresajuizados',
                    icon: 'fa fa-credit-card',
                    regras: 'CRED-DEVEDORES-00'
                }
            ]
        },
        // {
        //     name: 'Painel Credor',
        //     url: '/credores/painel',
        //     icon: 'fa fa-bar-chart',
        //     regras: ['CRED-PAINEL-00']
        // },
        // {
        //     name: 'Posição da Carteira',
        //     url: '/credores/carteiras',
        //     icon: 'fa fa-money',
        //     regras: ['CRED-CART-00']
        // },
        // {
        //     name: 'Recebimentos',
        //     url: '/credores/recebimentos',
        //     icon: 'fa fa-dollar',
        //     regras: ['CRED-RECEB-00']
        // },
        // {
        //     name: 'Títulos Devolvidos',
        //     url: '/credores/devolvidos',
        //     icon: 'fa fa-undo',
        //     regras: ['CRED-DEVOL-00']
        // },
        // {
        //     name: 'Parcelas Vencimento Credor',
        //     url: '/credores/parcelas',
        //     icon: 'fa fa-credit-card',
        //     regras: ['CRED-PARCELAS-00']
        // },
        {
            name: 'Recuperador',
            icon: 'fa fa-user',
            url: '/funcionarios',
            badge: {
                variant: 'primary',
                text: ''
            },
            regras: [
                'FUNC-PAINEL-00',
                'FUNC-DEVEDORES-00',
                'FUNC-PARCELAS-00',
                'FUNC-AGEND-00',
                'FUNC-CREDRECUP-00'
            ],
            children: [
                {
                    name: 'Painel',
                    url: '/funcionarios/painel',
                    icon: 'fa fa-bar-chart',
                    regras: ['FUNC-PAINEL-00']
                },
                {
                    name: 'Deved. sem acordo',
                    url: '/funcionarios/devedoressemacordo',
                    icon: 'fa fa-credit-card',
                    regras: 'FUNC-DEVEDORES-00'
                },
                {
                    name: 'Deved. com acordo',
                    url: '/funcionarios/devedorescomacordo',
                    icon: 'fa fa-credit-card',
                    regras: 'FUNC-DEVEDORES-00'
                },
                {
                    name: 'Parcelas Vencimento',
                    url: '/funcionarios/parcelas',
                    icon: 'fa fa-credit-card',
                    regras: ['FUNC-PARCELAS-00']
                },
                {
                    name: 'Agendamentos',
                    url: '/funcionarios/agendamentos',
                    icon: 'fa fa-calendar',
                    regras: ['FUNC-AGEND-00']
                },
                {
                    name: 'Sem Acionamentos',
                    url: '/funcionarios/semacionamentos',
                    icon: 'fa fa-calendar',
                    regras: ['FUNC-AGEND-00']
                },
                {
                    name: 'Créd. Recuperados',
                    url: '/funcionarios/creditosrecuperados',
                    icon: 'fa fa-dollar',
                    regras: ['FUNC-CREDRECUP-00']
                }
            ]
        },
        // {
        //     name: 'Painel',
        //     url: '/funcionarios/painel',
        //     icon: 'fa fa-bar-chart',
        //     regras: ['FUNC-PAINEL-00']
        // },
        // {
        //     name: 'Devedores',
        //     url: '/funcionarios/devedores',
        //     icon: 'fa fa-credit-card',
        //     regras: ['FUNC-DEVEDORES-00'],
        //     children: [
        //         {
        //             name: 'Sem acordo',
        //             url: '/funcionarios/devedoressemacordo',
        //             icon: 'fa fa-credit-card',
        //             regras: 'FUNC-DEVEDORES-00'
        //         },
        //         {
        //             name: 'Com acordo',
        //             url: '/funcionarios/devedorescomacordo',
        //             icon: 'fa fa-credit-card',
        //             regras: 'FUNC-DEVEDORES-00'
        //         }
        //     ]
        // },
        // {
        //     name: 'Parcelas Vencimento',
        //     url: '/funcionarios/parcelas',
        //     icon: 'fa fa-credit-card',
        //     regras: ['FUNC-PARCELAS-00']
        // },
        // {
        //     name: 'Agendamentos',
        //     url: '/funcionarios/agendamentos',
        //     icon: 'fa fa-calendar',
        //     regras: ['FUNC-AGEND-00']
        // },
        // {
        //     name: 'Sem Acionamentos',
        //     url: '/funcionarios/semacionamentos',
        //     icon: 'fa fa-calendar',
        //     regras: ['FUNC-AGEND-00']
        // },
        // {
        //     name: 'Créd. Recuperados',
        //     url: '/funcionarios/creditosrecuperados',
        //     icon: 'fa fa-dollar',
        //     regras: ['FUNC-CREDRECUP-00']
        // },
        {
            name: 'Painel de Faturamentos por Credor',
            url: '/paineis/faturamentos/credores',
            icon: 'fa fa-bar-chart',
            regras: ['PAINEL-FAT-00']
        },
        {
            name: 'Painel de Faturamentos por Recuperador',
            url: '/paineis/faturamentos/recuperadores',
            icon: 'fa fa-bar-chart',
            regras: ['PAINEL-FAT-01']
        },
        {
            name: 'Painel Acionamentos',
            url: '/paineis/acionreceb',
            icon: 'fa fa-bar-chart',
            regras: ['PAINEL-ACIONRECEB-00']
        },
        {
            name: 'Painel de Importações',
            url: '/paineis/importacoes',
            icon: 'fa fa-bar-chart',
            regras: ['PAINEL-IMPOR-00']
        },
        {
            name: 'Painel de Parcelas Vencimento por Recuperador',
            url: '/paineis/parcelas/recuperadores',
            icon: 'fa fa-bar-chart',
            regras: ['PAINEL-PARC-RECUP-00']
        },
        {
            name: 'Consutas em APIs',
            url: '/consultas',
            icon: 'fa fa-search',
            regras: ['APIS-00']
        }
        // {
        //   name: 'Finalizações',
        //   url: '/credenciados/finalizacoes',
        //   icon: 'fa fa-check-circle',
        //   regras: ['CRED-FIN-00']
        // },
        // {
        //   name: 'Contratações',
        //   url: '/gestores/contratacoes',
        //   icon: 'fa fa-book',
        //   regras: ['GEST-CONT-00']
        // },
        // {
        //   name: 'Entregas',
        //   url: '/gestores/entregas',
        //   icon: 'fa fa-calendar',
        //   regras: ['GEST-ENTR-00']
        // },
        // {
        //   name: 'Contratações',
        //   url: '/uabs/contratacoes',
        //   icon: 'fa fa-book',
        //   regras: ['UABS-CONT-00']
        // },
        // {
        //   name: 'Finalizações',
        //   url: '/uabs/finalizacoes',
        //   icon: 'fa fa-check-circle',
        //   regras: ['UABS-FIN-00']
        // }
    ]
}



// WEBPACK FOOTER //
// ./src/layout/_nav.js